<template>
  <div class="m-5">
    <div class="flex flex-wrap justify-between items-center pb-5 ">
      <div class="flex items-center">
        <h2 class=" text-primary-500 mb-0">
          Resources
        </h2>
      </div>

      <div class="flex items-center">
        <d-dropdown trap-focus>
          <d-icon slot="activator" icon="filter" class="text-black mr-5 p-2 bg-transparent" size="lg" />
          <div style="width:400px" class="py-3 px-5">
            <d-field label="Filter By" class="mb-5">
              <d-input v-model="filter" class="mb-2" placeholder="Title, Description, Category or Owner" />
            </d-field>
          </div>
        </d-dropdown>
        <d-btn @click="launchResourcesModal()">
          + Add Resource
        </d-btn>
      </div>
    </div>

    <d-tabs v-model="activeTab" :animated="false">
      <d-tab-item label="My Resources">
        <my-resources-iterator ref="myResources" :filter="filter" />
      </d-tab-item>
      <d-tab-item label="Resources Shared With Me">
        <shared-resources-iterator ref="sharedResources" :filter="filter" />
      </d-tab-item>
      <d-tab-item label="All Resources" v-if="hasRole('System Administrator')">
        <all-resources-iterator ref="allResources" :filter="filter" />
      </d-tab-item>
    </d-tabs>
  </div>
</template>

<script>
  import ResourceModal from '@resources/scripts/patterns/ResourceCard/ResourceModal.vue';
  import { mapGetters } from 'vuex';
  import MyResourcesIterator from './components/MyResourcesIterator.vue';
  import SharedResourcesIterator from './components/SharedResourcesIterator.vue';
  import AllResourcesIterator from './components/AllResourcesIterator.vue';

  export default {
    parent: true,
    components: {
      MyResourcesIterator,
      SharedResourcesIterator,
      AllResourcesIterator
    },

    data() {
      return {
        activeTab: 0,
        filter: '',
      };
    },

    computed: {
      ...mapGetters('d2Auth', ['profile','hasRole']),
    },

    methods: {
      launchResourcesModal() {
        this.$modal.open({
          parent: this,
          component: ResourceModal,
          width: 600,
          hasModalCard: true,
          props: {
            userId: this.profile.id,
          },
          events: {
            handleUpdate: () => {
              if (this.activeTab === 0) this.$refs.myResources.getResourcesPaged();
              if (this.activeTab === 1) this.$refs.sharedResources.getResourcesPaged();
              if (this.activeTab === 2) this.$refs.allResources.getResourcesPaged();
            },
          },
        });
      },
    },
  };
</script>